import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgWallet = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.5 3.25C3.12109 3.25 2 4.37109 2 5.75V18.25C2 19.6289 3.12109 20.75 4.5 20.75H19.5C20.8789 20.75 22 19.6289 22 18.25V9.5C22 8.12109 20.8789 7 19.5 7H5.125C4.78125 7 4.5 6.71875 4.5 6.375C4.5 6.03125 4.78125 5.75 5.125 5.75H19.5C20.1914 5.75 20.75 5.19141 20.75 4.5C20.75 3.80859 20.1914 3.25 19.5 3.25H4.5ZM18.25 12.625C18.5815 12.625 18.8995 12.7567 19.1339 12.9911C19.3683 13.2255 19.5 13.5435 19.5 13.875C19.5 14.2065 19.3683 14.5245 19.1339 14.7589C18.8995 14.9933 18.5815 15.125 18.25 15.125C17.9185 15.125 17.6005 14.9933 17.3661 14.7589C17.1317 14.5245 17 14.2065 17 13.875C17 13.5435 17.1317 13.2255 17.3661 12.9911C17.6005 12.7567 17.9185 12.625 18.25 12.625Z", fill: props.fill }));
});
export default SvgWallet;
